module.exports = __webpack_public_path__ + "static/Ipad-and-Phone-d377b28a61adf7277e01662087c8a0ac.jpg";